import { useNavigate } from "react-router-dom";
import "../../style/css/style.css";
import { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { verifyPayment, cancelBooking } from "../../services/PodService";
import { toast } from "react-toastify";

const VerifyPayment: React.FC = () => {
  const navigate = useNavigate();
  const pollingRef = useRef<number | null>(null);

  const [bookingDetails, setBookingDetails] = useState<{
    response: any;
    plan_name: string;
    pod_id: string | null;
  } | null>(null);

  const handleVerifyClick = async () => {
    const blrBookingId = localStorage.getItem("blrBookingId");
    const blrOrderId = localStorage.getItem("blrOrderId");
    if (!blrBookingId) {
      toast.error("No booking found to verify");
      return;
    }
    try {
      const verificationResponse = await verifyPayment({ booking_id: blrBookingId, order_id: blrOrderId || "" });
      if (verificationResponse?.status?.success) {
        if (pollingRef.current) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
        }
        navigate("/bookings");
      } else if (verificationResponse?.status?.reason === "payment_failed") {
        if (pollingRef.current) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
        }
        localStorage.removeItem("bookingDetails");
        localStorage.removeItem("blrBookingId");
        localStorage.removeItem("blrOrderId");
        navigate("/");
      } else if (verificationResponse?.status?.reason === "pending") {
        toast.error(verificationResponse?.status?.errorMessage || "Payment is pending");
      } else {
        toast.error(verificationResponse?.status?.errorMessage || "Payment not verified");
      }
    } catch (err) {
      console.error("Error verifying payment:", err);
      toast.error("Failed to verify payment. Please try again later.");
    }
  };

  const handleCancelClick = async () => {
    const blrBookingId = localStorage.getItem("blrBookingId");
    if (blrBookingId) {
      try {
        await cancelBooking(blrBookingId);
        toast.success("Booking cancelled successfully");
      } catch (err) {
        console.error("Error cancelling booking:", err);
        toast.error("Failed to cancel booking");
      }
    }
    // Clear polling
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
    // Clear localStorage
    localStorage.removeItem("bookingDetails");
    localStorage.removeItem("blrBookingId");
    localStorage.removeItem("blrOrderId");
    navigate(-1); // Go back
  };

  useEffect(() => {
    const bookingDetails = localStorage.getItem("bookingDetails");
    if (bookingDetails) {
      const parsedDetails = JSON.parse(bookingDetails);
      setBookingDetails(parsedDetails);
    }
  }, []);


  // add condition for failed payment 
  useEffect(() => {
    const poll = async () => {
      const blrBookingId = localStorage.getItem("blrBookingId");
      const blrOrderId = localStorage.getItem("blrOrderId");
      if (!blrBookingId) return;
      try {
        const verificationResponse = await verifyPayment({ booking_id: blrBookingId, order_id: blrOrderId || "" });
        if (verificationResponse?.status?.success) {
          if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
          }
          navigate("/bookings");
        } else if (verificationResponse?.status?.reason === "payment_failed") {
          if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
          }
          localStorage.removeItem("bookingDetails");
          localStorage.removeItem("blrBookingId");
          localStorage.removeItem("blrOrderId");
          navigate("/");
        }
      } catch (err) {
        console.error("Error verifying payment:", err);
      }
    };

    // Call once immediately
    poll();
    // Then every 30 seconds
    pollingRef.current = window.setInterval(poll, 30000);

    // Cleanup on unmount
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    };
  }, [navigate]);

  return (
    <div className="flex-container bg-black">
      <motion.div
        className="thank-you-container bg-white flex-grow p-[14px]"
        initial={{ opacity: 0, y: -75 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 75 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <div className="flex flex-col items-center">
          <div className="mb-6 rounded-md">
            <motion.img
              src="/EDC.png"
              alt="urban naps"
              style={{ width: "139px", height: "139px" }}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
            />
          </div>
          <motion.div
            className="text-base text-center text-[#2A2A34] font-semibold -mt-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Please process the payment on the machine
          </motion.div>
        </div>
        <div className="flex justify-center mt-4 space-x-4">
          <motion.button
            className={`confirm-button hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-lg w-[150px] text-sm bg-gray-500`}
            onClick={handleCancelClick}
            whileTap={{ scale: 0.95 }}
          >
            CANCEL
          </motion.button>
          <motion.button
            className={`confirm-button hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg w-[150px] text-sm bg-[#0E97E6]`}
            onClick={handleVerifyClick}
            whileTap={{ scale: 0.95 }}
          >
            VERIFY
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default VerifyPayment;